<template>
    <div id="app" v-cloak>
        <!-- pc -->
        <Pc v-if="!isMobile"></Pc>
        <!-- 移动端 -->
        <Mobile v-if="isMobile"></Mobile>
    </div>
</template>

<script>
import Pc from '@/pages/pc'
import Mobile from '@/pages/mobile'
import queryString from 'query-string'
import RE from '@/assets/replace.js'

let parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    components: {
        Pc,
        Mobile
    },
    data() {
        return {
            RE,
            isMobile: false
        }
    },
    mounted() {
        this.init();
        this.checkIfMobile();
        if (parsed.clear) {
            localStorage.clear();
        }
        if (parsed.downLoad) {
            this.isOs();
        }
    },
    methods: {
        // 区分移动还是pc
        checkIfMobile() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            this.isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        },
        isOs(){
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // 检查是否是 Android 设备
            if (/android/i.test(userAgent) || /Win32|Win64|Windows|WinCE/.test(userAgent)) {
                window.location.href = RE.AndUrl;
            }

            // 检查是否是 iOS 设备
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream || /Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
                window.location.href = RE.iosUrl;
            }
        },
        init() {
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
        },
    }
}
</script>

<style lang="less">
[v-cloak] {
    display: none;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    /* 移除所有图片在点击时的阴影 */
    &:active {
        box-shadow: none;
        outline: none;
    }
}

a {
    text-decoration: none;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
body {
    margin: 0;
    padding: 0;
    height: 100vh;
}
#app {
    position: relative;
    min-height: 100vh;
    text-align: center;
    box-sizing: border-box;
    overflow: hidden; /* 防止内容溢出 */
}
</style>




// WEBPACK FOOTER //
// src/App.vue